"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalCurrencyFilter = void 0;
var LocalCurrencyFilter = exports.LocalCurrencyFilter = function exports(Locale) {
  return function localCurrency(input, precision) {
    var parsedInput = parseFloat(input);
    if (isNaN(parsedInput)) {
      return input;
    }
    return Locale.formatCurrency(parsedInput, precision);
  };
};
LocalCurrencyFilter.$inject = ['Locale'];